<template>
  <div class="main">
    <!-- 查询区域 -->
    <div class="search-items">
      <el-radio-group v-model="timeRange" size="small">
        <el-radio-button label="day">日</el-radio-button>
        <el-radio-button label="week">周</el-radio-button>
        <el-radio-button label="month">月</el-radio-button>
      </el-radio-group>
    </div>

    <div class="content scrollable">
      <!-- 数据统计与全国热力分析 -->
      <el-row class="combined-section">
        <!-- 左侧：运营数据 -->
        <el-col :span="24">
          <div class="section-header">
            <span class="section-title">运营数据</span>
          </div>
          <div class="table-card unified-table">
            <el-table :data="filteredData" height="550" size="small" border>
              <el-table-column :label="timeLabel" width="120" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column prop="check_count" label="检测人数" width="100" align="center" />
              <el-table-column prop="unpaid_count" label="检测未付款人数" width="120" align="center" />
              <el-table-column prop="paid_count" label="检测已付款人数" width="120" align="center" />
              <el-table-column prop="total_order_amount" label="销售额" align="center">
                <template slot-scope="scope">
                  <span style="color: #409EFF; font-weight: 500;">¥{{ formatMoney(scope.row.total_order_amount) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="total_group_amount" label="收益流水" align="center">
                <template slot-scope="scope">
                  <span style="color: #409EFF; font-weight: 500;">¥{{ formatMoney(scope.row.total_group_amount) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getData } from '@/api/ik/data/dataApi'
import * as echarts from 'echarts'
import store from '@/store'
export default {
  name: 'OperationData',
  data() {
    return {
      timeRange: 'day',
      storeCode: store.getters['user/getStoreCode'],
      dataList: [],
      top5Cities: [
        { city: '上海市', detectCount: 15800, percentage: 100 },
        { city: '北京市', detectCount: 14250, percentage: 90 },
        { city: '广州市', detectCount: 12680, percentage: 80 },
        { city: '深圳市', detectCount: 11500, percentage: 73 },
        { city: '杭州市', detectCount: 9800, percentage: 62 }
      ],
      chinaMapChart: null
    }
  },
  computed: {
    filteredData() {
      return this.dataList
    },
    timeLabel() {
      const map = {
        day: '日期',
        week: '周次',
        month: '月份'
      }
      return map[this.timeRange] || '日期'
    }
  },
  watch: {
    timeRange() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
    this.initChinaMap()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chinaMapChart) {
      this.chinaMapChart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchData() {
      let url = ''
      switch (this.timeRange) {
        case 'day':
          url = 'daocui-board/board/diagnosis/phydiagrecordBoard/find/clinicCurrentMonthDailyCheckStat'
          break
        case 'week':
          url = 'daocui-board/board/diagnosis/phydiagrecordBoard/find/clinicCurrentMonthWeeklyCheckStat'
          break
        case 'month':
          url = 'daocui-board/board/diagnosis/phydiagrecordBoard/find/clinicCurrentYearMonthlyCheckStat'
          break
      }
      getData(url, { storeCode: this.storeCode }).then(res => {
        if (res.code === 1) {
          this.dataList = res.data || []
        }
      })
    },
    formatDate(row) {
      let dateStr = ''
      switch (this.timeRange) {
        case 'day':
          dateStr = row.stat_date || ''
          break
        case 'week':
          dateStr = row.stat_week || ''
          break
        case 'month':
          dateStr = row.stat_month || ''
          break
      }

      if (!dateStr) return ''

      if (this.timeRange === 'day' && dateStr.length >= 10) {
        return dateStr.substring(5, 10)
      }

      if (this.timeRange === 'month') {
        const parts = dateStr.split('-')
        const month = parts.length >= 2 ? parseInt(parts[1]) : parseInt(dateStr)
        return isNaN(month) ? dateStr : month + '月'
      }

      return dateStr
    },
    formatMoney(val) {
      if (val === null || val === undefined) return '0'
      return val.toLocaleString()
    },
    handleResize() {
      if (this.chinaMapChart) {
        this.chinaMapChart.resize()
      }
    },
    async initChinaMap() {
      this.$nextTick(async() => {
        const chartDom = this.$refs.chinaMap
        if (!chartDom) return

        this.chinaMapChart = echarts.init(chartDom)

        if (!echarts.getMap('china')) {
          try {
            const response = await fetch('https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json')
            const chinaJson = await response.json()
            echarts.registerMap('china', chinaJson)
          } catch (error) {
            console.error('中国地图数据加载失败:', error)
            return
          }
        }

        const mapData = [
          { name: '北京', value: 14250 },
          { name: '天津', value: 6800 },
          { name: '上海', value: 15800 },
          { name: '重庆', value: 7200 },
          { name: '河北', value: 4500 },
          { name: '河南', value: 5200 },
          { name: '云南', value: 3800 },
          { name: '辽宁', value: 4100 },
          { name: '黑龙江', value: 3200 },
          { name: '湖南', value: 5800 },
          { name: '安徽', value: 4900 },
          { name: '山东', value: 7600 },
          { name: '新疆', value: 2100 },
          { name: '江苏', value: 8900 },
          { name: '浙江', value: 9800 },
          { name: '江西', value: 4200 },
          { name: '湖北', value: 6100 },
          { name: '广西', value: 3500 },
          { name: '甘肃', value: 2800 },
          { name: '山西', value: 3900 },
          { name: '内蒙古', value: 2600 },
          { name: '陕西', value: 4700 },
          { name: '吉林', value: 3100 },
          { name: '福建', value: 5500 },
          { name: '贵州', value: 3300 },
          { name: '广东', value: 12680 },
          { name: '青海', value: 1800 },
          { name: '西藏', value: 1200 },
          { name: '四川', value: 6700 },
          { name: '宁夏', value: 2200 },
          { name: '海南', value: 2900 },
          { name: '台湾', value: 0 },
          { name: '香港', value: 0 },
          { name: '澳门', value: 0 }
        ]

        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}<br/>检测人数: {c}'
          },
          series: [
            {
              name: '检测人数',
              type: 'map',
              map: 'china',
              roam: true,
              zoom: 1.2,
              emphasis: {
                label: { show: true, color: '#fff' },
                itemStyle: { areaColor: '#ffd700' }
              },
              itemStyle: {
                borderColor: '#999',
                borderWidth: 0.5
              },
              data: mapData
            }
          ]
        }

        this.chinaMapChart.setOption(option)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;
  background: #f5f7fa;

  .search-items {
    height: 50px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    background: #fff;
    border-bottom: 1px solid #e4e7ed;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  }

  .content {
    position: absolute;
    width: 100%;
    height: calc(100% - 50px);
    top: 50px;
    padding: 15px;
    box-sizing: border-box;
  }

  .scrollable {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .combined-section {
    height: auto !important;
    background: transparent;

    .el-col-12 {
      padding: 0 10px;
    }
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px 10px;
    margin-bottom: 10px;
    border-bottom: 2px solid #E4E7ED;

    .section-title {
      font-size: 18px;
      font-weight: 900;
      color: #409EFF;
    }
  }

  .unified-table {
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    height: 100%;
  }

  .heatmap-unified {
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    height: 440px;

    .china-map-compact {
      width: 100%;
      height: 400px;
    }

    .top5-wrapper {
      padding-left: 15px;
      border-left: 1px solid #EBEEF5;
      display: flex;
      flex-direction: column;

      .top5-header {
        font-size: 14px;
        font-weight: bold;
        color: #303133;
        padding-bottom: 10px;
        border-bottom: 1px solid #EBEEF5;
        margin-bottom: 10px;
        flex-shrink: 0;
      }

      .top5-list-compact {
        flex: 1;
        overflow-y: auto;

        .top5-item {
          display: flex;
          align-items: center;
          padding: 15px 0;
          border-bottom: 1px solid #f5f5f5;

          &:last-child {
            border-bottom: none;
          }

          .rank {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 12px;
            color: white;
            margin-right: 8px;
            flex-shrink: 0;

            &.rank-1 {
              background: linear-gradient(135deg, #FFD700, #FFA500);
              box-shadow: 0 2px 6px rgba(255, 215, 0, 0.4);
            }

            &.rank-2 {
              background: linear-gradient(135deg, #C0C0C0, #A0A0A0);
              box-shadow: 0 2px 6px rgba(192, 192, 192, 0.4);
            }

            &.rank-3 {
              background: linear-gradient(135deg, #CD7F32, #B87333);
              box-shadow: 0 2px 6px rgba(205, 127, 50, 0.4);
            }

            &.rank-4, &.rank-5 {
              background: #909399;
            }
          }

          .city-info {
            flex: 1;
            min-width: 0;

            .city-name {
              font-size: 13px;
              font-weight: bold;
              color: #303133;
              margin-bottom: 3px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .city-count {
              font-size: 11px;
              color: #909399;
            }
          }

          .city-bar {
            width: 50px;
            height: 4px;
            background: #EBEEF5;
            border-radius: 2px;
            overflow: hidden;
            margin-left: 8px;

            .bar-fill {
              height: 100%;
              background: linear-gradient(90deg, #409EFF, #67C23A);
              border-radius: 2px;
              transition: width 0.5s ease;
            }
          }
        }
      }
    }
  }
}

.scrollable::-webkit-scrollbar {
  width: 8px;
}

.scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.scrollable::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
}

.scrollable::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.top5-list-compact::-webkit-scrollbar {
  width: 4px;
}

.top5-list-compact::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 2px;
}

</style>
